<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>
  It applies a "display: none" class (bootstrap "<b>d-none</b>) to the element if the input value is false.
</p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>

<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">
  
  <div class="row">
    <div class="col-4">
      <div [show]="isShowing">Showing a dynamic element</div>
    </div>
    <div class="col-3">
      <jb-switch [(ngModel)]="isShowing"></jb-switch>
    </div>
    <div class="col-5"> <pre>{{instance}}</pre> </div>
  </div>

</div>
